import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { MonthlyDivisionSummaryListing } from './Pages'

export const MonthlyDivisionSummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={MonthlyDivisionSummaryListing} />
    </Fragment>
)